import React from 'react'
import { ButtonGroup, Row, Col } from "react-bootstrap";
import User from "./../User";
import Credit from "./../Credit";
import CreditMobile from "./../Credit/Mobile";
import Logo from "./../Logo";
import Chat from "./../Chat";
import RealTime from "./../RealTime";
import MobileMenu from "./../Menu/MobileMenu";
import Notifications from "./../Notification";
import { isMobile, Event, BRAND } from "../../../../Helper";
import Wallett from '../../../Components/User/Wallett';
import Logout from "./../../Auth/Logout";
import Logout2 from "./../../Auth/Logout2";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileView: isMobile(),
            show: true,
            showComponent: false
        }
        this.handleResize = this.handleResize.bind(this);
        this.handleShow = this.handleShow.bind(this);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobileView: isMobile() });
    }

    handleShow(e) {
        console.log('clicked');
        this.setState({
            showComponent: true,
        });
    }

    collapse = () => {
        this.setState({ show: !this.state.show })
        Event.emit('toggle_sidebar', this.state.show);
    }

    desktop = () => {
        const { t, showUserDropdown, onToggleUserDropdown } = this.props;

        return (
            <div className="topbar-premium" id={'topbar'}>
                <Logo brand={BRAND} />
                <nav className="navbar-custom ml-auto">
                    <ul className="list-unstyled topbar-nav mb-0">
                        <li>
                            <Credit t={t} />
                        </li>
                        <li>
                            <Wallett t={t} />
                        </li>
                        <li>
                            <ButtonGroup>
                                <User t={t} show={showUserDropdown} onToggle={onToggleUserDropdown} />
                            </ButtonGroup>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }

    mobile = () => {
        const { t, showUserDropdown, onToggleUserDropdown } = this.props;
        return (
            <div className="topbar-premium" id={'topbar'}>
                <Logo brand={BRAND} />
                <nav className="navbar-custom ml-auto">
                    <ul className="list-unstyled topbar-nav mb-0">
                        <li>
                            <CreditMobile t={t} />
                        </li>
                        <li className="ml-1">
                            <Wallett t={t} />
                        </li>
                        <li>
                            <ButtonGroup>
                                <User t={t} show={showUserDropdown} onToggle={onToggleUserDropdown} />
                            </ButtonGroup>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }

    render() {
        return this.state.isMobileView ? this.mobile() : this.desktop();
    }
}

export default Header;